<template>
  <img
    :src="imgSrc"
    :alt="alt"
    v-bind="{ ...(id ? { id } : {}) }"
    @mouseenter="status = 'hover'"
    @mouseleave="status = 'default'"
    @click="status = 'active'"
  />
</template>
<script>
import { computed, defineComponent, ref } from '@nuxtjs/composition-api'

export default defineComponent({
  name: 'Icon',
  props: {
    id: {
      type: String,
      default: null
    },
    defaultSrc: {
      type: String,
      required: true
    },
    hoverSrc: {
      type: String,
      required: true
    },
    // if no set, use hoverSrc
    activeSrc: {
      type: String,
      default: null
    },
    alt: {
      type: String,
      default: ''
    }
  },
  setup(props, context) {
    const status = ref('default') // default || hover || active

    const imgSrc = computed(() => {
      let result = ''
      switch (status.value) {
        case 'active':
          result = props.activeSrc || props.hoverSrc
          break
        case 'hover':
          result = props.hoverSrc
          break
        default:
          result = props.defaultSrc
          break
      }
      return result
    })

    return {
      status,
      imgSrc
    }
  }
})
</script>
